import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function AboutUs() {
  const { ref: sectionRef, isVisible } = useScrollReveal();

  return (
    <section ref={sectionRef} id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className={`relative transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
            <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/ab328d9d68a2a91f3ff829b424941413.jpeg"
                alt="Professional spray foam insulation installation in Yuma"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-blue-900 rounded-2xl -z-10"></div>
          </div>

          {/* Content */}
          <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              About Our Company
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Since 2001, Yuma Spray Foam Pros has been the leading provider of professional spray foam insulation services in Yuma, Arizona. Our team of certified technicians specializes in both residential and commercial insulation projects.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We understand the unique challenges of Arizona's extreme climate and provide tailored insulation solutions that maximize energy efficiency, reduce utility costs, and improve indoor comfort year-round.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-default group">
                <div className="text-4xl font-bold text-blue-900 mb-2 group-hover:scale-110 transition-transform duration-300">24+</div>
                <div className="text-gray-700 font-medium">Years Experience</div>
              </div>
              <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-default group">
                <div className="text-4xl font-bold text-emerald-700 mb-2 group-hover:scale-110 transition-transform duration-300">2000+</div>
                <div className="text-gray-700 font-medium">Projects Completed</div>
              </div>
            </div>

            <a
              href="/about-yuma-insulation"
              className="inline-flex items-center gap-2 bg-blue-900 hover:bg-blue-800 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 hover:-translate-y-1 cursor-pointer whitespace-nowrap group"
            >
              <span>Learn More About Us</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform duration-300"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}